<template>
    <div class="mb-4">
        <div class="hidden border-gray-325 bg-white shadow md:block">
            <div class="flex items-center justify-between p-4">
                <div class="mb-2 text-[16px] font-semibold text-gray-900">
                    Your Organization
                </div>

                <div
                    class="flex justify-between gap-2 rounded border border-gray-325 text-[16px] text-gray-625"
                >
                    <div class="flex items-center justify-center px-2">
                        <text-clamp
                            autoResize
                            :max-lines="1"
                            :text="$page.props.auth.user.group.name"
                        >
                        </text-clamp>
                    </div>
                    <div
                        class="flex h-8 h-full items-center justify-center bg-gray-325 p-2"
                    >
                        <text-clamp
                            autoResize
                            :max-lines="1"
                            :text="$page.props.auth.user.classroom.name"
                        >
                        </text-clamp>
                    </div>
                </div>
            </div>
            <table class="table-striped w-full" v-if="shouldShowGoals">
                <thead
                    class="text-left text-[14px] font-semibold text-gray-625"
                >
                    <th class="whitespace-nowrap p-2 pl-4">Classroom Goal</th>
                    <th class="w-16 whitespace-nowrap p-2">Time Period</th>
                    <th class="whitespace-nowrap p-2 pl-12">Progress</th>
                </thead>
                <tbody>
                    <template v-for="goal in classroomGoals">
                        <tr
                            v-if="goal.enabled"
                            class="border-t border-gray-325 odd:bg-gray-50"
                        >
                            <td
                                class="whitespace-nowrap p-2 pl-4 text-[16px] font-semibold"
                            >
                                <span v-if="goal.type == 'study_hours'"
                                    >Study for {{ goal.target }} hours</span
                                >
                                <span v-if="goal.type == 'answer_questions'"
                                    >Answer {{ goal.target }} questions</span
                                >
                            </td>
                            <td
                                class="whitespace-nowrap p-2 text-[16px] text-gray-625"
                            >
                                Since
                                <span class="font-semibold">
                                    {{
                                        dayjs(goal.startingFrom)
                                            .utc(false)
                                            .tz($page.props.auth.user.timezone)
                                            .format(
                                                $page.props.date_formats
                                                    .short_nice
                                            )
                                    }}
                                </span>
                            </td>
                            <td class="whitespace-nowrap p-2 pl-12 text-[16px]">
                                <div class="flex items-center gap-4">
                                    <div class="">
                                        <new-progress-ring
                                            :radius="32"
                                            :percent-filled="
                                                Math.round(
                                                    goal.progressPercent * 100
                                                )
                                            "
                                            height="64px"
                                        />
                                    </div>
                                    <div class="text-[16px] text-gray-625">
                                        <span v-if="goal.type == 'study_hours'"
                                            >{{ goal.points }}/{{
                                                goal.target
                                            }}
                                            hours</span
                                        >
                                        <span
                                            v-if="
                                                goal.type == 'answer_questions'
                                            "
                                            >{{ goal.points }}/{{
                                                goal.target
                                            }}
                                            questions</span
                                        >
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
        <div
            class="flex flex-col gap-2 border-gray-325 bg-white p-4 shadow md:hidden"
        >
            <div
                class="flex justify-between gap-2 rounded border border-gray-325 text-[16px] text-gray-625"
            >
                <div class="flex items-center justify-center px-2">
                    <text-clamp
                        autoResize
                        :max-lines="1"
                        :text="$page.props.auth.user.group.name"
                    >
                    </text-clamp>
                </div>
                <div
                    class="flex h-8 h-full items-center justify-center bg-gray-325 p-2"
                >
                    <text-clamp
                        autoResize
                        :max-lines="1"
                        :text="$page.props.auth.user.classroom.name"
                    >
                    </text-clamp>
                </div>
            </div>
            <div
                v-for="goal in classroomGoals"
                class="flex justify-between gap-4 border-b border-gray-325 py-3 last-of-type:border-b-0"
            >
                <div class="flex flex-col gap-1">
                    <div class="">
                        <span v-if="goal.type == 'study_hours'"
                            >Study for {{ goal.target }} hours</span
                        >
                        <span v-if="goal.type == 'answer_questions'"
                            >Answer {{ goal.target }} questions</span
                        >
                    </div>
                    <div class="flex gap-2 text-gray-625">
                        <div class="">
                            Since
                            <span class="font-semibold">
                                {{
                                    dayjs(goal.startingFrom)
                                        .utc(false)
                                        .tz($page.props.auth.user.timezone)
                                        .format(
                                            $page.props.date_formats.short_nice
                                        )
                                }}
                            </span>
                        </div>
                        <div class="">•</div>
                        <div class="">
                            <span v-if="goal.type == 'study_hours'"
                                >{{ goal.points }}/{{ goal.target }} hrs</span
                            >
                            <span v-if="goal.type == 'answer_questions'"
                                >{{ goal.points }}/{{ goal.target }} qs</span
                            >
                        </div>
                    </div>
                </div>
                <div class="">
                    <new-progress-ring
                        :radius="32"
                        :percent-filled="Math.round(goal.progressPercent * 100)"
                        height="64px"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import NewProgressRing from "@/Components/NewProgressRing.vue";

export default {
    name: "StudentGroupClassroomGoals",
    components: { NewProgressRing },
    props: {
        classroomGoals: {
            type: Array,
            default: [],
        },
    },
    computed: {
        shouldShowGoals() {
            let vm = this;
            let enabledGoals = [];

            enabledGoals = _.filter(vm.classroomGoals, function (goal) {
                return goal.enabled;
            });

            if (enabledGoals.length) {
                return true;
            } else {
                return false;
            }
        },
    },
};
</script>
